import React from "react";
import { FormControlLabel } from "@mui/material";
import { Data, SectionKeysType } from "../../store/terminal/types";
import { FormikProps, useFormikContext } from "formik";
import CustomizedSwitch from "../formElements/Switch";

interface UpdateSectionProps {
  name: string;
  disabled?: boolean;
}

const UpdateSection: React.FC<UpdateSectionProps> = ({ name, disabled }) => {
  const [, section] = name.split(".");
  const formikProps = useFormikContext();
  const { values, setFieldValue } = formikProps as FormikProps<Data>;

  let checked = false;
  if (values.sections && values.sections[section as SectionKeysType]) {
    checked = !!values.sections[section as SectionKeysType];
  }

  return (
    <FormControlLabel
      style={{ marginLeft: "5px" }}
      control={
        <CustomizedSwitch
          name={name}
          checked={checked}
          onChange={(e, data) => {
            setFieldValue(name, data);
          }}
          disabled={disabled}
        />
      }
      label="Update Section"
    />
  );
};

export default UpdateSection;
